var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"campus-info-container"},[_c('pc-navbar'),_c('block-overview'),_c('div',{staticClass:"campus-info-content"},[_c('block-campus-tab',{attrs:{"tab-list":_vm.tabList,"active-index":_vm.activeIndex},on:{"clickTab":_vm.clickTab}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }